module.exports = __webpack_public_path__ + "img/advisory_solve3_icon_05.7012e5bd.png";